import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Course } from '../../../models/course'
import { Teacher } from '../../../models/teacher'
import { Resources } from '../../../models/resources'
import { instanceToInstance } from 'class-transformer'
import { TeacherProvider } from '../../../providers/teacher/teacher.provider'
import { Router } from '@angular/router'
import { MenuPopoverComponent } from '../../../components/menu-popover/menu-popover.component'
import {
  MessagePopoverButton,
  MessagePopoverComponent
} from '../../../components/message-popover/message-popover.component'
import { PopoverController } from '@ionic/angular'
import { PreferencesProvider } from '../../../providers/preferences/preferences.provider'
import { ResourcesProvider } from '../../../providers/resources/resources.provider'
import { CourseCssService } from '../course-css.service'
import { Lesson } from '../../../models/lesson'
import { TeacherStore } from 'src/app/stores/teacher.store';
import { Subject, map, takeUntil } from 'rxjs';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss']
})
export class CourseComponent implements OnInit {

  @Input() course: Course

  _resources: Resources = Resources.defaults()
  get resources(): Resources { return this._resources }
  @Input() set resources(resources: Resources) { this._resources = resources ||  Resources.defaults() }

  _teacher: Teacher = Teacher.defaults()
  get teacher(): Teacher { return this._teacher }
  @Input() set teacher(teacher: Teacher) { this._teacher = teacher ||  Teacher.defaults() }

  @Output() courseArchiveAction = new EventEmitter()

  ngUnsubscribeTeacher = new Subject();

  // NOTE: Any actions performed on courseBeingEdited are done on that object itself. We do
  // not make those changes through the teacherProvider API until we are ready to save
  // the courseBeingEdited. It is always possible we could cancel the editing session.

  // get courseBeingEdited(): Course { 
  //   // console.log('IN courseBeingEdited');
  //   // console.log(this.teacher);
  //   return this.teacher.coursesBeingEdited.get(this.course.uuid) 
  // }

  isEditing: boolean  = false

  constructor(
    private router: Router,
    private popoverCtrl: PopoverController,
    private teacherProvider: TeacherProvider,
    // private teacherStore: TeacherStore,
    // private resourcesProvider: ResourcesProvider,
    private preferencesProvider: PreferencesProvider,
    public courseCssService: CourseCssService) { }

  ngOnInit() {
    // this.teacherStore.state$
    //     .pipe(
    //       takeUntil(this.ngUnsubscribeTeacher),
    //       map((teacher: Teacher) => {
    //         this.teacher = teacher
    //       })
    //     )
    //     .subscribe(() => {});
  }

  saveEditCourse() {
    /* 
      calling below line of code is hitting Update API multiple time(size of lesson array times) 
      and after this entire system doesn't update any thing until angular server is restarted on
      different port.
    */
    // this.course.lessons.forEach((lesson: Lesson) => {
    //   this.teacherProvider.adjustNumSongs(lesson, this.courseBeingEdited.getLessonCounts)
    //   this.teacherProvider.updateLesson(this.courseBeingEdited, lesson, false)
    // })
    // this.teacherProvider.updateCourse(this.courseBeingEdited)
    this.isEditing = false;
    // this.teacher.coursesBeingEdited.delete(this.course.uuid)
    this.course.isDirty = true;
    this.teacherProvider.updateCourse(this.course);
    this.teacherProvider.saveTeacher()
  }

  ngOnDestroy(){
    this.ngUnsubscribeTeacher.next(true);
    this.ngUnsubscribeTeacher.complete();
  }

  cancelEditCourse() {
    // this.teacher.coursesBeingEdited.delete(this.course.uuid)
    this.isEditing = false;
    this.teacherProvider.saveTeacher()
  }

  gotoBowlingPage() {
    this.router.navigate(['bowling', this.course.uuid])
  }

  isCourseExpanded() {
    return this.preferencesProvider.isCourseExpanded(this.course)
  }

  toggleCourseExpanded() {
    this.preferencesProvider.setCourseExpanded(this.course, !this.preferencesProvider.isCourseExpanded(this.course))
  }

  showCourseMenu(event) {
    if (!this.course.isArchived) {
      MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event, [
        {name: 'Edit Semester', icon: 'mt-edit', action: () => {this.editCourse()}},
        {name: 'Duplicate', icon: 'mt-copy', action: () => {this.duplicateCourse()}},
        {name: 'Archive', icon: 'mt-archive', action: () => {this.archiveCourse()}},
        {name: 'Delete', icon: 'mt-trash', action: () => {this.deleteCourse()}},
      ], 250)
    } else {
      MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event, [
        {name: 'Un-archive', icon: 'mt-un-archive', action: () => {this.unarchiveCourse()}},
        {name: 'Delete', icon: 'mt-trash', action: () => {this.deleteCourse()}},
      ], 250)
    }
  }

  duplicateCourse() {
    const course = this.course.unsavedCopy()
    this.teacherProvider.addCourse(course)
  }

  archiveCourse() {
    const course = instanceToInstance(this.course)
    course.isArchived = true
    this.teacherProvider.updateCourse(course)
    this.courseArchiveAction.emit()
  }

  unarchiveCourse() {
    const course = instanceToInstance(this.course)
    course.isArchived = false
    this.teacherProvider.updateCourse(course)
    this.courseArchiveAction.emit()
  }

  deleteCourse() {
    MessagePopoverComponent.present(this.popoverCtrl, 'Are You Sure You Want to Delete This?', 'This action cannot be undone.', false, false, [
      { name: 'Cancel', type: MessagePopoverButton.Type.Cancel },
      { name: 'Delete', type: MessagePopoverButton.Type.Submit, action: () => { this.teacherProvider.deleteCourse(this.course) }}
    ])
  }

  editCourse() {
    if (!this.isEditing) {
      if (!this.isCourseExpanded()) {
        this.toggleCourseExpanded()
      }
      // this.teacher.coursesBeingEdited.set(this.course.uuid, instanceToInstance(this.course))
      this.isEditing = true;
      this.teacherProvider.saveTeacher()
    }
  }
}
